import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { ControlStockModel } from './controlstock.model';
import { ControlStockService } from './controlstock.service';

@Component({
    selector: 'convfact-controlstock',
    templateUrl: './controlstock.component.html',
    styleUrls: ['./controlstock.component.css'],
    standalone: false
})

export class ControlStockComponent implements OnInit {

  controlstock = new ControlStockModel;

  constructor(
    private controlStockService: ControlStockService,
    private route: ActivatedRoute,
    private router: Router,
    public snackBar: MatSnackBar,
  ) { }

  ngOnInit() {
    const temp = this.route.params['_value'];
    const uid = temp['controlstockUid'];

    if (uid != null) {
      this.controlStockService.get(uid).then(controlstock => {
        this.controlstock = controlstock;

      });
    }
  }

  saveData(controlstock: ControlStockModel) {

    if (controlstock.uid == null) {

      this.controlStockService.create(controlstock)
        .then(controlstock => {
          this.controlstock = controlstock;
          this.returnToIndex();
        }).catch(err => {
          this.displayInfo('Ha ocurrido un error inesperado al crear el stock');
        })
    } else {
      this.controlStockService.update(controlstock)
        .then(controlstock => {
          this.controlstock = controlstock;
          this.returnToIndex();
        }).catch(err => {
          this.displayInfo('Ha ocurrido un error inesperado al guardar el stock');
        })
    }
  }

  returnToIndex() {
    this.router.navigate(['/concept/controlstock']);
  }

  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

}
